// GSAP + ScrollTrigger are loaded on demand instead of in the entry bundle, so they stay off the
// critical path. Every caller awaits the same import; the plugin is registered once.
type GsapModules = { gsap: typeof import('gsap').gsap; ScrollTrigger: typeof import('gsap/ScrollTrigger').ScrollTrigger }

let gsapPromise: Promise<GsapModules> | null = null

export function loadGsap(): Promise<GsapModules> {
  gsapPromise ||= Promise.all([import('gsap'), import('gsap/ScrollTrigger')]).then(([{ gsap }, { ScrollTrigger }]) => {
    gsap.registerPlugin(ScrollTrigger)
    gsap.config({
      force3D: true,
      autoSleep: 60,
      nullTargetWarn: false,
    })
    return { gsap, ScrollTrigger }
  })
  return gsapPromise
}

// Run `cb` when the browser is idle (or after `timeout` ms at the latest).
export function onIdle(cb: () => void, timeout = 2000) {
  if ('requestIdleCallback' in window) window.requestIdleCallback(cb, { timeout })
  else setTimeout(cb, 200)
}
